// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1SVZZ","buttons":"SendReceipts_buttons__JvIbP","email":"SendReceipts_email__Gp2jF","bookApptTitle":"SendReceipts_bookApptTitle__VJrLq"};